<template>
    <div class="user-picker">
        <multiselect
            v-model="selected"
            label="name"
            track-by="id"
            :placeholder="$t('admin.userPicker.placeholder')"
            open-direction="bottom"
            :options="users"
            :multiple="false"
            :searchable="true"
            :loading="busy"
            :internal-search="false"
            :clear-on-select="false"
            :close-on-select="true"
            :show-no-results="true"
            :hide-selected="false"
            @search-change="search"
            @input="select"
        >
            <template slot="singleLabel" slot-scope="props">
                <div class="option__desc">
                    <span class="option__title">{{ props.option.name }} ({{ props.option.email }})</span>
                </div>
            </template>
            <template slot="option" slot-scope="props">
                <div class="option__desc">
                    <span class="option__title">{{ props.option.name }} ({{ props.option.email }})</span>
                </div>
            </template>
            <span slot="noResult">{{ $t("admin.userPicker.noResult") }}</span>
        </multiselect>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import CommonComponents from "@/views/shared";
import FKApi, { SimpleUser } from "@/api/api";

import "vue-multiselect/dist/vue-multiselect.min.css";

export default Vue.extend({
    name: "UserPicker",
    components: { ...CommonComponents },
    props: {},
    mounted() {
        this.blockAutofill();
    },
    data(): {
        busy: boolean;
        users: SimpleUser[];
        selected: SimpleUser[];
    } {
        return {
            busy: false,
            users: [],
            selected: [],
        };
    },
    methods: {
        async search(query: string): Promise<void> {
            this.busy = true;
            if (query.length == 0) {
                this.users = [];
            } else {
                const response = await new FKApi().adminSearchUsers(query);
                this.users = response.users;
            }
            this.busy = false;
        },
        select(user: SimpleUser): void {
            this.$emit("select", user);
        },
        blockAutofill(): void {
            const input = this.$el.querySelector("input");
            if (input) {
                input.setAttribute("type", "search");
                input.setAttribute("autocomplete", "off");
                input.setAttribute("name", `fk_search_${Math.random().toString(36).slice(2)}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
::v-deep .multiselect,
::v-deep .multiselect__input,
::v-deep .multiselect__single {
    font-size: 13px;
    font-family: var(--font-family);
    color: var(--color-dark);
}

::v-deep .multiselect {
    min-height: 34px;
    box-sizing: border-box;
}

::v-deep .multiselect__tags {
    min-height: 34px;
    padding: 6px 36px 6px 10px;
    border: 1px solid var(--color-border);
    border-radius: 3px;
    background: #fff;
    font-size: 13px;
}

::v-deep .multiselect__input,
::v-deep .multiselect__single {
    padding: 0;
    margin-bottom: 0;
    line-height: 20px;
    background: transparent;
    border-radius: 0;
}

::v-deep .multiselect__input::placeholder {
    color: #9aa1ab;
}

::v-deep .multiselect__placeholder {
    font-size: 13px;
    font-family: var(--font-family);
    color: #9aa1ab;
    margin-bottom: 0;
    padding-top: 0;
    line-height: 20px;
}

::v-deep .multiselect__select {
    height: 34px;
}

::v-deep .multiselect__spinner {
    height: 32px;

    &::before,
    &::after {
        border-top-color: var(--color-primary);
    }
}

::v-deep .multiselect__content-wrapper {
    border: 1px solid var(--color-border);
    border-top: none;
    border-radius: 0 0 3px 3px;
}

::v-deep .multiselect__option {
    font-size: 13px;
    font-family: var(--font-family);
    color: var(--color-dark);
    padding: 8px 12px;
    min-height: unset;
    white-space: normal;

    &::after {
        display: none;
    }
}

::v-deep .multiselect__option--highlight {
    background: var(--color-primary);
    color: #fff;
}

::v-deep .multiselect__option--selected {
    background: #f4f5f7;
    color: var(--color-dark);
    font-weight: normal;
    font-family: var(--font-family-medium);

    &.multiselect__option--highlight {
        background: var(--color-primary);
        color: #fff;
    }
}
</style>
